import React from 'react';
import { Link } from 'react-router-dom'; // Import Link for navigation
// import { HiHome } from 'react-icons/hi'; // Example icon for the home/dashboard link


const Breadcrumb = ({ items }) => {
    return (
        <nav className="flex mb-6" aria-label="Breadcrumb">
            <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
                {items.map((item, index) => {
                    const isLast = index === items.length - 1;

                    return (
                        <li key={index} className="inline-flex items-center">
                            {/* Render separator if it's not the first item */}
                            {index > 0 && (
                                <div className="flex items-center">
                                    <svg className="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4" />
                                    </svg>
                                </div>
                            )}

                            {isLast ? (
                                // Last item (current page) is not a link
                                <span className="ms-1 text-sm font-medium text-gray-500 md:ms-2 dark:text-gray-400" aria-current={item.current ? 'page' : undefined}>
                                    {item.label}
                                </span>
                            ) : (
                                // Other items are links
                                <Link
                                    to={item.url}
                                    className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white"
                                >
                                    {item.icon && React.createElement(item.icon, { className: "w-4 h-4 me-2.5" })}
                                    {item.label}
                                </Link>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};

export default Breadcrumb;